<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 教育经历 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">教育经历</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="学校名称" prop="schoolName">
                <el-input
                  v-model="form.schoolName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="所学专业" prop="majorIn">
                <el-cascader
                  style="width: 100%"
                  filterable
                  clearable
                  :options="classDataTree"
                  v-model="TreeOptions"
                  @change="addressChoose"
                  ref="cascader_Ref"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="学历" prop="educationLevel">
                <el-select
                  v-model="form.educationLevel"
                  placeholder="请选择学历"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in education"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="毕业时间" prop="graduateYear">
                <el-date-picker
                  clearable
                  v-model="form.graduateYear"
                  type="year"
                  value-format="yyyy"
                  placeholder="请选择毕业时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  clearable
                  v-model="form.startTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  clearable
                  v-model="form.endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>
<script>
import {
  personalInfo,
  undergraduateMajorList,
  educationExperienceCommit
} from "@/api/index";

import { Debounce, handleTree } from "@/helper/utilities.js";
export default {
  name: "resume-basic",
  data() {
    return {
      education: [
        "博士",
        "硕士",
        "本科",
        "大专",
        "中专",
        "中计",
        "高中",
        "初中",
        "其他"
      ],
      classDataTree: [], //大学专业
      TreeOptions: [],
      form: {
        miniProgramEducationId: undefined,
        schoolName: undefined,
        majorId: undefined,
        majorIn: undefined,
        educationLevel: undefined,
        graduateYear: undefined,
        // startTime: undefined,
        // endTime: undefined
      },
      rules: {
        // schoolName: [
        //   { required: true, message: "姓名不能为空", trigger: "blur" }
        // ],
        majorIn: [
          { required: true, message: "所学专业不能为空", trigger: "change" }
        ],
        educationLevel: [
          { required: true, message: "学历不能为空", trigger: "change" }
        ],
        // graduateYear:[
        //   { required: true, message: "毕业时间不能为空", trigger: "change" }
        // ],
        // startTime: [
        //   { required: true, message: "开始时间不能为空", trigger: "blur" }
        // ],
        // endTime: [
        //   { required: true, message: "结束时间不能为空", trigger: "blur" }
        // ]
      }
    };
  },
  created() {
    this.getundergraduateMajorList();
    let id = this.$route.params.id;
    if (id) {
      this.getPersonalInfo(id);
    }
  },
  methods: {
    getPersonalInfo(id) {
      personalInfo()
        .then(res => {
          if (res.code == 200) {
            this.form = res.data.educationExperienceList.find(
              item => item.miniProgramEducationId == id
            );
            let arr = [];
            this.findParent(this.classDataTree, this.form.majorId, arr);
            this.TreeOptions = arr.reverse();
          }
        })
        .catch(err => {});
    },

    //通过子级找父级
    findParent(list, id, arr) {
      for (let item of list) {
        if (item.value == id) {
          arr.push(item.value); //要id就push item.id, 要对象就push item
          return true;
        }
        if (item.children && item.children.length > 0) {
          let isFind = this.findParent(item.children, id, arr);
          if (isFind) {
            arr.push(item.value); //要id就push item.id, 要对象就push item
            return true;
          }
        }
      }
      return false;
    },

    //获取专业
    getundergraduateMajorList() {
      undergraduateMajorList().then(res => {
        res.data.shift();
        let list = handleTree(res.data, "majorId", "parentId");
        this.classDataTree = this.changeListFiled(list);
      });
    },

    changeListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach(t => {
          let newItem = {
            label: t.majorName,
            value: t.majorId,
            children: t.children
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeListFiled(t.children);
          }
        });
      }
      return newList;
    },

    addressChoose(value) {
      if (value.length > 0) {
        this.form.majorId = value[1];
        this.form.majorIn = this.$refs.cascader_Ref
          .getCheckedNodes()[0]
          .pathLabels.join(" / ");
      } else {
        this.form.majorId = "";
        this.form.majorIn = "";
      }
    },

    submit: Debounce(function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          educationExperienceCommit(this.form).then(res => {
            if (res.code == 200) {
              this.$router.go(-1);
              this.$message({
                showClose: true,
                message: "保存成功",
                type: "success"
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "warning"
              });
            }
          });
        }
      });
    }, 1000)
  }
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
